import script from "./MapRight.vue?vue&type=script&setup=true&lang=js"
export * from "./MapRight.vue?vue&type=script&setup=true&lang=js"

import "./MapRight.vue?vue&type=style&index=0&id=676a9b89&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676a9b89"]])

export default __exports__